module.exports = __webpack_public_path__ + "static/img/ROME_MAPLE.20e3fcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/ROME_MAPLE.jpg
// module id = L9Mr
// module chunks = 0